<template>
    <div class="session-expired-alert-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-pdv-small modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <img src="/images/featured/close-circle-menu.svg" alt="close-circle-menu" /> 
                </button>
                <div class="d-flex justify-content-center mt-4">
                    <img src="/images/featured/IconButtonRelod.svg" alt="IconButtonRelod" />
                </div>
                <div class="main-content">
                    <!--img src="/images/iconos/clock-white.svg" alt=""-->

                    <h3>SE ACABARON LOS {{time}} MINUTOS DE RESERVA PARA TUS CUPOS</h3>
                    <p>Tu lugar quedará asegurado una vez que se realice el pago. Apresurate a pagar antes que se ocupen los horarios que seleccionaste.</p>
                    <!--a href="#" @click="onContinue" data-dismiss="modal" class="btn-pdv-primary ">OK,ENTIENDO</a-->
                </div>
                <div class="d-flex justify-content-center">
                <Button 
                  title="Entendido"
                  type="secundario"
                  size="medium"
                  @onClick="onContinue"
                  data-dismiss="modal" aria-label="Close"
                />
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import {TIME_EXPIRED_PAGE_TIMER} from '@/constants'
    import Button from "@/components/featured/Button";

    export default {
        data(){
            return {    
                time : moment(TIME_EXPIRED_PAGE_TIMER,'mm:ss').format("mm")
            }
        },
        components: {
            Button
        },
        methods : {
            onContinue(){
                window.$('#helperSessionExpiredModal')[0].click();
            }
        }
    }
</script>

<style scoped lang="scss">
    .session-expired-alert-modal {
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv-small {
            max-width: 481px;
            .modal-content{
                border-radius: 24px;
                border: 2px solid $neutralBlack;
                background: $neutralwhite;
                padding: 24px;
                box-shadow: 0 0 12px 3px #00000038;
                min-height: 381px;
                
                button.close{
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    opacity: 1;
                    span{
                        font-size: 30px;
                        color: #fff;
                    }
                }
                .main-content{
                    text-align: center;
                    margin-bottom: 40px;
                    img{
                        width: 65px;
                        margin-bottom: 20px;
                    }
                    h3{
                        color: #592466;
                        text-align: center;
                        font-family: 'Poppins-Bold', sans-serif;
                        font-size: 32px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 42px;
                        margin-bottom: 10px;
                    }
                    p {
                        color: $neutralBlack;
                        text-align: center;
                        font-family: 'Poppins-Regular', sans-serif;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                        margin-bottom: 0px;
                    }
                    .btn-pdv-primary{
                        padding: 14px 40px;
                    }
                }
            }

        }
    }

</style>